import PouchDB from 'pouchdb';
import {IReportOpenCloseStore} from '../../models/openclosestore/IReportOpenCloseStore';
import TaskClient from '../TaskClient';
import Secrets from '@yumi/secrets';


class OpenCloseStoreOfflineClient {
  constructor(private readonly db_name: string) {
  }

  async saveData(data: any, operation?: string) {
    data.operation = operation;
    console.log('saveData', data, operation)
    const db_task = new PouchDB(this.db_name);
    await db_task.post({
      data: {
        iReportOpenCloseStore: data
      }
    });

    return {
      ok: true
    };
  }

  async sendToCloud(item: IReportOpenCloseStore) {
    return await TaskClient.createReport(item, 'OPENCLOSESTORE', item.operation);
  }

  async cleanPushDB() {
    const db = new PouchDB(this.db_name);
    const allDocs = await db.allDocs({include_docs: true});
    if (allDocs.total_rows <= 0) {
      return;
    }

    const rows = allDocs.rows;
    for (let index = 0; allDocs.total_rows > index; index++) {
      await db.remove(rows[index].id, rows[index].value.rev);
    }

    await db.compact();
  }
}

export default new OpenCloseStoreOfflineClient(
  Secrets.REACT_APP_POUCHDB_DB_OFFLINE_QUEUE_NAM2 ||
  'OPENCLOSESTORE_OFFLINE_DATA'
);
